import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import ExpandCollapseButton from "../../../components/expand-collapse-button/expand-collapse-button";
import { DashboardExport } from "../../../assets/icons";
import { GetRealEstateDealTrackerExcelExport, GetRealEstateWorklogExcelExport } from "../../../services/api/dashboard-api";

const DashboardTableHeader = ({ trackerType, accordionId, collapsed, setCollapsed, toggled, setToggled, taskId = 0}) => {
    const isDealTracker = trackerType === "dealtracker";
    const isWorkLog = trackerType === "worklog";

    const titles = {
        dealtracker: "Ongoing Deals and PTO, by Associate/Analyst",
        worklog: "Work Log"
    };

    return (
        <th className="DashboardTableTitle expand-collapse-button-test">
            {titles[trackerType]}
            <div className="DashboardTableHeaderButtons">
                {   isDealTracker && (
                    <React.Fragment>
                        <ExpandCollapseButton
                            className="expand-collapse-button-test"
                            accordionId={accordionId}
                            collapsed={collapsed}
                            setCollapsed={setCollapsed}
                            toggled={toggled}
                            setToggled={setToggled}
                        />
                        <OverlayButton
                            icon={DashboardExport}
                            tooltip="Export Deal Tracker"
                            onClick={() => console.log("Export Deal Tracker")}
                            // onClick={() => GetRealEstateDealTrackerExcelExport("")}
                        />
                    </React.Fragment>
                )}
                {   isWorkLog && (
                    <React.Fragment>
                        <ExpandCollapseButton
                            className="expand-collapse-button-test"
                            accordionId={accordionId}
                            collapsed={collapsed}
                            setCollapsed={setCollapsed}
                            toggled={toggled}
                            setToggled={setToggled}
                        />
                        <OverlayButton
                            icon={DashboardExport}
                            tooltip="Export Work Log"
                            onClick={() => console.log("Export Worklog Tracker")}
                            // onClick={() => GetRealEstateWorklogExcelExport()}
                        />
                    </React.Fragment>
                )}
            </div>
            <p className="subDepartmentTitle">GIB/Real Estate</p>
        </th>
    );
};

const OverlayButton = ({ icon, tooltip, onClick }) => (
    <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
        <img src={icon} onClick={onClick} alt={tooltip} />
    </OverlayTrigger>
);

OverlayButton.propTypes = {
    icon: PropTypes.string.isRequired,
    tooltip: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

DashboardTableHeader.propTypes = {
    trackerType: PropTypes.oneOf(['dealtracker', 'worklog']).isRequired,
    accordionId: PropTypes.string.isRequired,
    collapsed: PropTypes.bool.isRequired,
    setCollapsed: PropTypes.func.isRequired,
    toggled: PropTypes.array.isRequired,
    setToggled: PropTypes.func.isRequired,
    taskId: PropTypes.number,
};

export default DashboardTableHeader;
